import React, { useState, useRef, useEffect } from "react";
import "./Blog.css";
import blogData from "../../api/blogData";
import RewardsData from "../../api/RewardsData";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Pagination } from "swiper/modules";
import { useSEO } from "../../context/SEOContext";
import { useTranslation } from "react-i18next";
import MagazineSection from "../../components/Magazine/MagazineSection";
const Blog = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("blog.meta.title"),
      description: t("blog.meta.description"),
      keywords: t("blog.meta.keywords"),
      favicon: "/faviconnew.png", // ✅ burada favicon tanımlandı
    });
  }, [setSeo, t]);
  const [selectedImage, setSelectedImage] = useState(null);
  const modalRef = useRef(null);

  const handleImageClick = (img) => {
    setSelectedImage(img);
    const modal = new window.bootstrap.Modal(modalRef.current);
    modal.show();
  };

  return (
    <>
      <div className="container">
        {/* Başlık */}
        <div className="row">
          <h1 className="mb-4 mt-5 text-center fw-normal">MÜKEMEL</h1>
        </div>
        <hr />

        {/* Bloglar */}
        <div className="row">
          {blogData.blogs.map((blog, index) => {
            if (index % 4 === 0) {
              const blog1 = blogData.blogs[index];
              const blog2 = blogData.blogs[index + 1];
              const blog3 = blogData.blogs[index + 2];
              const blog4 = blogData.blogs[index + 3];

              return (
                <React.Fragment key={index}>
                  {/* Sol sütun */}
                  <div className="col-lg-6">
                    {blog1 && (
                      <Link
                        to={blog1.url}
                        className="text-decoration-none text-dark"
                        target="_blank"
                      >
                        <img
                          src={blog1.images}
                          alt={blog1.title}
                          className="mt-3 w-100 img-responsive"
                        />
                        <div className="py-3">
                          <h5>{blog1.title}</h5>
                        </div>
                      </Link>
                    )}

                    {blog3 && (
                      <Link
                        to={blog3.url}
                        className="text-decoration-none text-dark"
                        target="_blank"
                      >
                        <img
                          src={blog3.images}
                          alt={blog3.title}
                          className="mt-3 w-100 img-responsive2"
                        />
                        <div className="py-3">
                          <h5>{blog3.title}</h5>
                        </div>
                      </Link>
                    )}
                  </div>

                  {/* Sağ sütun */}
                  <div className="col-lg-6">
                    {blog2 && (
                      <Link
                        to={blog2.url}
                        className="text-decoration-none text-dark"
                        target="_blank"
                      >
                        <img
                          src={blog2.images}
                          alt={blog2.title}
                          className="mt-3 w-100 img-responsive2"
                        />
                        <div className="py-3">
                          <h5>{blog2.title}</h5>
                        </div>
                      </Link>
                    )}

                    {blog4 && (
                      <Link
                        to={blog4.url}
                        className="text-decoration-none text-dark"
                        target="_blank"
                      >
                        <img
                          src={blog4.images}
                          alt={blog4.title}
                          className="mt-3 w-100 img-responsive"
                        />
                        <div className="py-3">
                          <h5>{blog4.title}</h5>
                        </div>
                      </Link>
                    )}
                  </div>

                  <hr className="mt-4 mb-4" />
                </React.Fragment>
              );
            }
            return null;
          })}
        </div>

        {/* Rewards bölümü */}
        <div className="row mb-5">
          <h1 className="mb-4 mt-5 text-center fw-normal">{t("Rewards")}</h1>
          <hr />
          <div className="col-lg-12">
            <Swiper
              slidesPerView={3}
              spaceBetween={30}
              freeMode={true}
              pagination={{ clickable: true }}
              modules={[FreeMode, Pagination]}
              className="mySwiper"
              breakpoints={{
                0: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1440: { slidesPerView: 4 },
              }}
            >
              {RewardsData.rewards.map((reward, re) => (
                <SwiperSlide key={reward.id || re} className="mb-5">
                  <img
                    src={reward.images}
                    alt={reward.title}
                    className="mt-3 w-100 img-responsive"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleImageClick(reward.images)}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Bootstrap Modal */}
            <div
              className="modal fade"
              id="imageModal"
              tabIndex="-1"
              aria-labelledby="imageModalLabel"
              aria-hidden="true"
              ref={modalRef}
            >
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="imageModalLabel">
                      {t("blog.imagePreview")}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body text-center">
                    {selectedImage && (
                      <img
                        src={selectedImage}
                        alt={t("blog.imagePreview")}
                        className="img-fluid"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MagazineSection />
    </>
  );
};

export default Blog;
